import {msg} from "@lingui/macro"
import DateTimeInput from "../form-component/DateTimeInput"
import TelInput from "../form-component/TelInput"
import TextInput from "../form-component/TextInput"
import {useLingui} from "@lingui/react"
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    InputLabel,
    List,
    ListItem,
    MenuItem,
    Select,
    Tooltip,
    Typography
} from "@mui/material"
import {useState} from "react"
import dayjs from "dayjs"
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {IconButton, TextField} from "@mui/material/";
import {Remove} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";

const SecondPage = ({
                        control,
                        selectedRegion,
                        setSelectedRegion,
                        regions,
                        isMobile,
                        pageIndex,
                        setPageIndex,
                        getValues,
                        draft,
                        setDraft
                    }) => {
    const {_} = useLingui()
    const [openAlert, setOpenAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')

    const isEmptyOrSpaces = str => {
        if (typeof str == 'string') {
            return /^\s*$/g.test(str)
        }
    }

    const verifyAndNext = () => {
        console.log('click')
        const formValues = getValues()
        console.log('formValues ', formValues)
        const firstName = formValues.firstName
        const lastName = formValues.lastName
        const location = formValues.location
        const crashLocationSplit = location.replace(' ', '').split(',')
        const longitude = +crashLocationSplit[0]
        const latitude = +crashLocationSplit[1]
        const date = formValues.date
        const region = selectedRegion
        const email = formValues.email
        const phoneNumber = formValues.phoneNumber

        if ((!isEmptyOrSpaces(firstName) && !isEmptyOrSpaces(lastName) && !isEmptyOrSpaces(location) && !isEmptyOrSpaces(date) && region)) {

            if (!phoneNumber && !email) {
                setAlertMessage('Please insert phone number or email to continue')
                setOpenAlert(true)
            } else if (phoneNumber.length < 7 && phoneNumber.length > 0) {
                setAlertMessage('Please insert a valid phone number')
                setOpenAlert(true)
            } else if (email.length > 0 && !email.includes('@')) {
                setAlertMessage('Please insert a valid email')
                setOpenAlert(true)
            } else {
                const data = {
                    code: dayjs(new Date()).format('YYYY-MM-DD:HHmmss'),
                    data: dayjs(new Date()).format('YYYY-MM-DD hh:mm'),
                    firstName: firstName,
                    lastName: lastName,
                    phoneNumber: phoneNumber,
                    email: email,
                    longitude: longitude,
                    latitude: latitude,
                    regionFk: region.id
                }
                setDraft({
                    publicAccident: data
                })
                setPageIndex(pageIndex + 1)
                /*
                const res = await savePublicAccident(data)
                if (!res.responseAnyError) {
                    setPublicAccident(res.responseData)
                    setPageIndex(pageIndex + 1)
                }
                    */
            }
        } else {
            setOpenAlert(true)
            setAlertMessage('Please insert values to continue')
        }
    }

    return (
        <>
            <Box sx={{padding: 4}}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginBottom: 2
                }}>
                    <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <Tooltip title={'Previous'}>
                            <IconButton onClick={() => {
                                setPageIndex(pageIndex - 1)
                            }} variant="contained" sx={{display: 'flex', flex: 1}}>
                                <ChevronLeftIcon/>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'Next'}>
                            <IconButton onClick={() => verifyAndNext()} variant="contained"
                                        sx={{display: 'flex', flex: 1}}>
                                <NavigateNextIcon/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1}}>
                    <Box sx={{
                        width: isMobile ? '100%' : '30%',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px;'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 2,
                            backgroundColor: '#5cbec4',
                            borderBottom: '1px solid lightgrey'
                        }}>
                            <Typography sx={{fontWeight: 700,color:'white'}}>Provide the following information</Typography>
                        </Box>
                        <List sx={{display: 'flex', overflowY: 'auto', flexDirection: 'column', flex: 1}}>
                            <ListItem>
                            <TextInput
                                name={'firstName'}
                                control={control}
                                label={_(msg`Your Name`)}
                            />
                            </ListItem>
                            <ListItem>
                            <TextInput
                                name={'lastName'}
                                control={control}
                                label={_(msg`Your Last Name`)}
                            />
                            </ListItem>
                            <ListItem>
                            <TelInput
                                name={'phoneNumber'}
                                control={control}
                                type={'number'}
                                label={_(msg`Phone number`)}
                            />
                            </ListItem>
                            <ListItem>
                            <TextInput
                                name={'email'}
                                control={control}
                                label={_(msg`Email`)}
                            />
                            </ListItem>
                            <ListItem>
                            <DateTimeInput name={'date'} control={control}
                                           label={_(msg`Crash Date and Time`)}></DateTimeInput>
                            </ListItem>
                            {/** start select box */}
                            <ListItem>
                            <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, width: '100%'}}>
                                <InputLabel id="select-label">Region *</InputLabel>
                                <Select
                                    labelId="select-label"
                                    value={selectedRegion}
                                    sx={{width: '100%'}}
                                    onChange={(e) => {
                                        setSelectedRegion(e.target.value)
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 200,
                                                overflowY: 'auto',
                                            },
                                        },
                                    }}
                                 variant={'outlined'}>
                                    {regions.map((region, k) => {
                                        return (
                                            <MenuItem key={k} value={region}>{region.name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </Box>
                            </ListItem>
                            {/** end select box */}
                        </List>
                    </Box>
                </Box>

            </Box>
            {openAlert &&
                <Alert sx={{width: '80%', marginLeft: '10%'}} action={
                    <Button onClick={() => {
                        setOpenAlert(false)
                    }} color="inherit" size="small">
                        <CloseIcon/>
                    </Button>
                } severity="error">
                    <Typography>{alertMessage}</Typography>
                </Alert>
            }
        </>
    )
}
export default SecondPage